import { jsx as p } from "react/jsx-runtime";
import { Stack as r } from "@mui/material";
const a = ({
  children: o,
  ...t
}) => /* @__PURE__ */ p(r, { gap: "6px", ...t, children: o });
export {
  a as SideNavSections
};
//# sourceMappingURL=index128.mjs.map
